import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth/index";
import { setupForegroundListener } from "./firebase";

const App = () => {

  // 2. Call it once when the App loads
  useEffect(() => {
    setupForegroundListener();
  }, []);

  return (
    <Routes>
      <Route path="/" element={<AuthLayout />} />
      <Route path="admin/*" element={<AdminLayout />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default App;